export default __webpack_public_path__ + "static/media/menuRemover.daa47377.svg";